// extracted by mini-css-extract-plugin
export default {"root":"PlasmicParagraph_root__lAMBP","p__eBjmB":"PlasmicParagraph_p__eBjmB__lVoJh"};